import forge from 'node-forge';
import * as constants from '../appConstants';

export function signPayload(payload: string, authValues: any) {
    const stringToSign = constants.AMAZON_SIGNATURE_ALGORITHM + '\n' +
        hashAndHex(payload);

    return signString(stringToSign, authValues);
}

/* Expected options:
       options.method
       options.urlFragment
       options.payload
       options.headers
       options.host
*/
export function signHeaders(options, authValues: any) {

    const headers = {};

    Object.assign(headers, options.headers);

    headers['x-amz-pay-region'] = authValues.region;
    headers['x-amz-pay-host'] = options.host;
    headers['x-amz-pay-date'] = getTimestamp();
    headers['content-type'] =  'application/json';
    headers['accept'] = 'application/json';

    const lowercaseSortedHeaderKeys = Object.keys(headers).sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    });
    const signedHeaders = lowercaseSortedHeaderKeys.join(';');

    let payload = options.payload;
    if (payload === null || payload === undefined) {
        payload = '';
    }

    let canonicalRequest = options.method + '\n/'
        + (options.urlFragment).split('?')[0] + '\n'
        + getParametersAsString(options.queryParams) + '\n';
    lowercaseSortedHeaderKeys.forEach(item => canonicalRequest += item.toLowerCase() + ':' + headers[item] + '\n');
    canonicalRequest += '\n' + signedHeaders + '\n' + hashAndHex(payload);

    const stringToSign = constants.AMAZON_SIGNATURE_ALGORITHM + '\n' +
        hashAndHex(canonicalRequest);

    const signature = signString(stringToSign, authValues);

    headers['authorization'] = constants.AMAZON_SIGNATURE_ALGORITHM
        + ' PublicKeyId=' + authValues.publicKeyId
        + ', SignedHeaders=' + signedHeaders
        + ', Signature=' + signature;

    // Don't sign the user-agent header, because Chrome's fetch API will not respect the override
    // and Chrome will send the browser's user-agent instead.
    headers['user-agent'] = 'amazon-pay-scratchpad';
    if (authValues.authToken) {
        headers['x-amz-pay-authtoken'] = authValues.authToken;
    }

    const signedComponents = {
        headers: headers,
        canonicalRequest: canonicalRequest,
        stringToSign: stringToSign
    };

   return signedComponents;
}

function getTimestamp() {
    const date = new Date();
    return date.toISOString().split('.')[0] + 'Z';
}

function hashAndHex(data: string) {
    const md = forge.md.sha256.create();
    md.update(data);
    return md.digest().toHex();
}

function signString(stringToSign: string, authValues: any) {
    if (Object.entries(authValues.privateKey).length == 0) {
      return "UNABLE_TO_SIGN_NO_KEY_LOADED";
    }

    const md = forge.md.sha256.create();
    md.update(stringToSign, 'utf8');

    const pss = forge.pss.create({
        md: forge.md.sha256.create(),
        mgf: forge.mgf.mgf1.create(forge.md.sha256.create()),
        saltLength: 20
    });

    return btoa(authValues.privateKey.sign(md, pss));
}

export function getQueryString(requestParams) {
    if (requestParams) return `?${getParametersAsString(requestParams)}`;
    return '';
}
 
export function getParametersAsString(requestParams) {
    if (!requestParams) return '';
 
    let queryParams: any[] = [];
    Object.keys(requestParams).sort().forEach(function (param) {
        queryParams.push(`${param}=${encodeURIComponent(requestParams[param])}`);
    });
    return queryParams.join('&');
}